import { CoreApplicationContext, CoreUser } from '@eventbrite/context-gen';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { getUser, STATSIG_CLIENT_KEY, STATSIG_ENV } from '@eventbrite/statsig';
import React from 'react';
import { StatsigOptions, StatsigSynchronousProvider } from 'statsig-react';

interface ConditionalStatsigSynchronousProviderProps {
    user: CoreUser;
    context: CoreApplicationContext;
    initializeValues?: Record<string, unknown>;
    options?: StatsigOptions;
}

const ENV_TO_STATSIG_ENV_MAP: { [key in EBEnvs]?: string } = {
    [EBEnvs.DEV]: STATSIG_ENV.DEV,
    [EBEnvs.QA]: STATSIG_ENV.QA,
    [EBEnvs.PROD]: STATSIG_ENV.PROD,
};

export const ConditionalStatsigSynchronousProvider: React.FunctionComponent<
    ConditionalStatsigSynchronousProviderProps
> = (props) => {
    const currentEnv = getCurrentEnv(props.context);

    if (props.initializeValues) {
        return (
            <StatsigSynchronousProvider
                initializeValues={props.initializeValues}
                sdkKey={STATSIG_CLIENT_KEY}
                user={getUser(props.user)}
                options={{
                    ...props.options,
                    environment: {
                        tier: currentEnv
                            ? ENV_TO_STATSIG_ENV_MAP[currentEnv]
                            : '',
                    },
                }}
            >
                {props.children}
            </StatsigSynchronousProvider>
        );
    }

    return <>{props.children}</>;
};
